import styled from "styled-components";
import { Colors } from "../../config/Constants";

export const StyledTabs = styled.div`
  .tabs {
    &__list {
      padding-left: 0;
    }
    &__item {
      display: inline-block;
      font-family: "Poppins-Medium";
      font-size: 1.25rem;
      padding: 0.25rem 0.625rem;
      text-align: center;
      color: ${Colors.black};
      border-bottom: 1px solid ${Colors.altoApprox};
      @media only screen and (max-width: 538px) {
        width: 5.625rem;
        font-size: 1rem;
      }
      &.active {
        color: ${Colors.appleRed};
        border-bottom: 1px solid ${Colors.appleRed};
      }
      &:hover {
        cursor: pointer;
      }
    }
  }
`;
